/* global jQuery google */

// eslint-disable-next-line no-unused-vars
const mapStyle = [
{
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#68bae7"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
        ]
    },
    {
		"featureType": "road",
		"elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]

const DEFAULT_BOUNDS = {
	north: 66.933465987735616,
	south: 49.09466907684661,
	west: -22.145933991390892,
	east: 10.9119244765624913
}

const featureStyleOptions = {
	strokeColor: "#0079c2",
	strokeOpacity: 1,
	strokeWeight: 2,
	fillColor: '#272829',
	fillOpacity: 1,
}

const DEFAULT_CENTER = { lat: 56.336000, lng: -3.959389 }
var local_markers = []
const searchInputField = document.getElementById('postcode')
var map
var initMap

	; (function ($) {
		/*
		 *  initMap
		 *
		 *  Will be fired when the Google Maps API has loaded, reassigns global function
		 */
		// eslint-disable-next-line no-func-assign

		initMap = function () {
			$('.google-map').each(function () {
				newMap($(this))
			})
		}

		/*
		 *  render a Google Map onto the selected jQuery element
		 */
		function newMap($el) {
			var $markers = $el.find('.marker')

			if ($el.attr('id') === 'location-map') {
				//location map
				var args = {
					zoom: parseInt($el.data('zoom')),
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					//mapId: '9ed4324086c6c9c3', //Different ID
					styles: mapStyle,
				}

				map = new google.maps.Map($el[0], args)

				// Add marker to map
				$markers.each(function () {
					addMarker($(this), map)
				})

				centerMap(map)
			} else {
				//general map
				var args = {
					zoom: parseInt($el.data('zoom')),
					minZoom: 5,
					maxZoom: 20,
					center: DEFAULT_CENTER,
					restriction: {
						latLngBounds: DEFAULT_BOUNDS,
						strictBounds: true
					},
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					mapId: '9ed4324086c6c9c3'  //Different ID
				}

				map = new google.maps.Map($el[0], args)

				/**autocomplete */
				const options = {
					fields: ["formatted_address", "geometry", "name"],
					bounds: DEFAULT_BOUNDS,
					componentRestrictions: { country: 'gb' }
				}

				/*
				const autocomplete = new google.maps.places.Autocomplete(searchInputField, options)
				autocomplete.bindTo("bounds", map);
				autocomplete.addListener('place_changed', async () => {

					var place = autocomplete.getPlace()
					if (!place.geometry) {
						//console.log('no place geometry...');
					} else {
						//console.log(place);
						findClosestMarker(place.geometry.location);
					}
				})
				*/

				window.addEventListener("resize", function () {
					updateMapView(map)
				});

				/**draw layer  */
				let featureLayer = map.getFeatureLayer("COUNTRY");
				// Below Place ID is "UK"
				let placeId = 'ChIJqZHHQhE7WgIReiWIMkOg-MQ';
				// Apply the style to a single boundary.

				featureLayer.style = (options) => {
					if (options.feature.placeId == placeId) {
						return featureStyleOptions;
					}
				}

				// Add marker to map
				$markers.each(function () {
					addMarker($(this), map)
				})

				updateMapView(map)
			}

		}

		/*
		 *  add a marker to the selected Google Map
		 */
		function addMarker($marker, map) {
			var latlng = new google.maps.LatLng(
				$marker.attr('data-lat'),
				$marker.attr('data-lng')
			)
			const marker = new google.maps.Marker({
				position: latlng,
				map: map,
				icon: new google.maps.MarkerImage($marker.attr('data-icon')),
				title: $marker.attr('data-title'),
			})

			//map.markers.push(marker)
			// if marker contains HTML, add it to an infoWindow
			if ($marker.html()) {

				const infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				})

				marker.infowindow = infowindow;

				marker.addListener("click", () => {

					//close all markers;
					hideAnyMarkerInfowindow()
					//open clicked one
					infowindow.open({
						anchor: marker,
						map,
					});

					infowindow.addListener("closeclick", () => {
						unSelectItemInMapList()
					})

				});
			}

			local_markers.push(marker)

			return marker;
		}

		/*** Responsive issue*/

		function updateMapView(map) {
			var w = window.innerWidth;
			map.setZoom(7);
			if (w < 991) {
				map.setZoom(6);
			}
			if (w < 769) {
				map.setZoom(6);
			}

			map.setCenter(DEFAULT_CENTER);
		}

		/**
		* Find the closest marker and popup
		*	@arg place.location
		*/
		function findClosestMarker(location) {
			let current_position = { lat: location.lat(), lng: location.lng() }
			let selected = local_markers.reduce(function (prev, curr) {
				var cpos = google.maps.geometry.spherical.computeDistanceBetween(current_position, curr.position);
				var ppos = google.maps.geometry.spherical.computeDistanceBetween(current_position, prev.position);

				return cpos < ppos ? curr : prev;
			})

			new google.maps.event.trigger(selected, 'click');
			let targetLocationSlug = selected.title.replace(' Office', '').toLowerCase().replace(' ', '-')
			unSelectItemInMapList()
			$('#' + targetLocationSlug).addClass('selected');
		}

		/* un select any location on map list*/
		function unSelectItemInMapList() {
			$('.v-location .list .list-wrapper a').removeClass('selected')
		}
		/**
		* close any marker infowindow
		*/
		function hideAnyMarkerInfowindow() {
			for (var i = 0; i < local_markers.length; i++) {
				local_markers[i].infowindow.close()
			}
		}

		/**
		*	close infowindow when start searching
		*/
		if (searchInputField != null) {
			searchInputField.addEventListener('keyup', () => { hideAnyMarkerInfowindow() }, false);
		}
		/**
		 *  center the map, showing all markers attached
		 */
		function centerMap(map) {
			var bounds = new google.maps.LatLngBounds()
			// loop through all markers and create bounds
			$.each(local_markers, function (i, marker) {
				var latlng = new google.maps.LatLng(
					marker.position.lat(),
					marker.position.lng()
				)
				bounds.extend(latlng)
			})
			if (local_markers.length === 1) {
				map.setCenter(bounds.getCenter())
			} else {
				map.fitBounds(bounds)
			}
		}

	})(jQuery)
